import type { CombinedStatement } from '../../banking/types/Statement';
import type { TaxDocument } from '../../banking/types/TaxDocument';
import { requestBuilder } from '../../http/RequestBuilder';
import { FORMER_MEMBER_API } from '../api/FormerMemberApi';

export interface FormerMemberBankingAccess {
    userId: string;
    membershipId: string | null;
    membershipLabel: string;
    statements: CombinedStatement[];
    taxDocuments: TaxDocument[];
}

export interface FormerMemberInvestmentAccount {
    userId: string;
    membershipId: string | null;
    membershipLabel: string;
    apexAccountId: string;
    nickname: string;
}

export interface FormerMemberPortalResponse {
    banking: FormerMemberBankingAccess[];
    investments: FormerMemberInvestmentAccount[];
}

export const useFormerMemberPortal = () => {
    return useGetPortal({});
};

const useGetPortal = requestBuilder.query<FormerMemberPortalResponse>({
    endpoint: `${FORMER_MEMBER_API}/portal`,
    queryKey: 'formerMemberPortal',
});
